const carouselItems = [
  {
    id: 1,
    title: '韩漫崛起：2024年度TOP50',
    desc: '盘点本年度最受欢迎的韩漫作品，从恋爱甜宠到热血格斗，带你全面了解韩国漫画的魅力与多样性。',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20colorful%20Korean%20manhwa%20cover%20art%20collage%20with%20various%20genres%2C%20warm%20orange%20and%20amber%20gradient%20overlay%2C%20vibrant%20illustrations%2C%20dramatic%20lighting%2C%20editorial%20layout%20style%2C%20clean%20cream%20background&width=1000&height=600&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    id: 2,
    title: '日漫经典：那些值得重温的神作',
    desc: '从《龙珠》到《鬼灭之刃》，经典日漫的永恒魅力经久不衰，一起回顾那些影响一代人的漫画传奇。',
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20Japanese%20manga%20art%20collage%20featuring%20classic%20shonen%20characters%2C%20warm%20sepia%20and%20golden%20tones%2C%20vintage%20manga%20panel%20aesthetic%2C%20dramatic%20composition%2C%20clean%20cream%20background&width=1000&height=600&seq=carousel-02&orientation=landscape',
    tag: '经典回顾',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 3,
    title: '下拉式 vs 翻页式：哪种阅读方式更适合你？',
    desc: '深度对比YY漫画三种阅读模式的使用场景与体验差异，帮你找到最舒适的漫画阅读姿势。',
    image: 'https://readdy.ai/api/search-image?query=A%20split%20screen%20comparison%20of%20digital%20comic%20reading%20interfaces%20showing%20scroll%20mode%20and%20page%20flip%20mode%20side%20by%20side%2C%20modern%20clean%20UI%20design%2C%20warm%20neutral%20tones%2C%20editorial%20presentation%20style%2C%20clean%20cream%20background&width=1000&height=600&seq=carousel-03&orientation=landscape',
    tag: '阅读指南',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 4,
    title: '新番速递：七月最值得追的漫画',
    desc: '本月新上线的高分漫画作品全收录，从热血少年到治愈日常，帮你锁定下一个心头好。',
    image: 'https://readdy.ai/api/search-image?query=A%20fresh%20vibrant%20manga%20cover%20art%20collage%20with%20new%20release%20badges%2C%20summer%20theme%20with%20bright%20coral%20and%20mint%20accents%2C%20modern%20editorial%20design%2C%20Japanese%20and%20Korean%20comic%20art%20mix%2C%20clean%20cream%20background&width=1000&height=600&seq=carousel-04&orientation=landscape',
    tag: '新番速递',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    id: 5,
    title: '漫画创作者访谈：对话人气画师',
    desc: '独家专访热榜漫画背后的创作者，揭秘从灵感到成稿的创作历程，了解漫画世界的幕后故事。',
    image: 'https://readdy.ai/api/search-image?query=An%20artistic%20illustration%20of%20a%20manga%20artist%20studio%20workspace%20with%20sketches%20and%20digital%20tablet%2C%20warm%20ambient%20lighting%2C%20creative%20atmosphere%2C%20editorial%20photography%20style%2C%20muted%20earthy%20tones%2C%20clean%20cream%20background&width=1000&height=600&seq=carousel-05&orientation=landscape',
    tag: '幕后故事',
    tagColor: 'bg-primary-100 text-primary-700',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-22 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            深度内容与精选专题，探索漫画世界的更多可能
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className={`bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group ${
                item.id === 1 ? 'lg:col-span-2' : ''
              } ${item.id === 5 ? 'sm:col-span-2 lg:col-span-3' : ''}`}
            >
              <div className={`flex flex-col ${item.id === 1 || item.id === 5 ? 'md:flex-row' : ''}`}>
                <div
                  className={`relative overflow-hidden flex-shrink-0 ${
                    item.id === 1 || item.id === 5
                      ? 'md:w-[55%]'
                      : 'w-full'
                  }`}
                  style={{ aspectRatio: item.id === 1 || item.id === 5 ? '16/9' : '16/10' }}
                >
                  <img
                    src={item.image}
                    alt={`YY漫画专题 - ${item.title}`}
                    title={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className={`px-2.5 py-1 rounded-md text-xs font-bold ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <h3 className="font-heading text-lg md:text-xl text-foreground-900 leading-snug">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                  <span className="inline-flex items-center gap-1.5 mt-4 text-sm text-primary-600 font-medium cursor-pointer whitespace-nowrap group-hover:text-primary-700 transition-colors">
                    阅读全文 <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}